import { ref, shallowRef } from 'vue'

export function usePolling<T>() {
  const data = shallowRef<T | null>(null)
  const isActive = ref(false)
  let intervalId: NodeJS.Timeout | null = null

  function startPolling(request: () => Promise<T>, intervalTime: number = 2000) {
    isActive.value = true

    const poll = async () => {
      try {
        console.debug('Polling...')
        const response = await request()
        data.value = response
      }
      catch (error) {
        console.error('Polling error:', error)
      }
    }

    poll() // Initial poll

    intervalId = setInterval(poll, intervalTime) // Poll every 2 seconds
  }

  function stopPolling() {
    console.debug('stopPolling...')
    isActive.value = false
    if (intervalId) {
      clearInterval(intervalId)
      intervalId = null
    }
  }

  return {
    pollingData: data,
    isActive,
    startPolling,
    stopPolling,
  }
}
